import { firestoreDB } from '../firebase'

const firebaseRecursoCollection = 'recurso'

const guardarNuevoRecurso = recurso =>
  firestoreDB
    .collection(firebaseRecursoCollection)
    .doc()
    .set(recurso)

const obtenerRecursos = () => firestoreDB.collection(firebaseRecursoCollection).get()

const obtenerRecurso = id =>
  firestoreDB
    .collection(firebaseRecursoCollection)
    .doc(id)
    .get()

const eliminarRecurso = recurso =>
  firestoreDB
    .collection(firebaseRecursoCollection)
    .doc(recurso.id)
    .delete()

const editarRecurso = recurso =>
  firestoreDB
    .collection(firebaseRecursoCollection)
    .doc(recurso.id)
    .set(recurso)

export const firebaseRecursosRepository = {
  guardarNuevoRecurso,
  eliminarRecurso,
  editarRecurso,
  obtenerRecursos,
  obtenerRecurso,
}
